import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

const ProgressSpinner = ({ classes, isProcessing }) => {
    if (isProcessing) {
        return <CircularProgress size={15} />
    }
    else {
        return null;
    }
}

const styles = theme => ({
    progressSpinner: {
        height: 15,
        width: 15
    }
})

export default withStyles(styles)(ProgressSpinner);